import dynamic from "next/dynamic";

export const InfoGrid = dynamic(() => import("./component"));
